// extracted by mini-css-extract-plugin
module.exports = {"dashboardHeader":"dashboard_dashboardHeader__2VLVA","dashboardTitle":"dashboard_dashboardTitle__2xh-h","dashboardSubtitle":"dashboard_dashboardSubtitle__2vUF3"};